var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHatchbakHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29439",
    "data-name": "Group 29439",
    transform: "translate(-221 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(221 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_13_",
    "data-name": "svgexport-17 (13)",
    transform: "translate(237 588.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50503",
    "data-name": "Path 50503",
    d: "M491.944,282.017l-.7-.369v.707Zm0,0",
    transform: "translate(-470.28 -269.627)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50504",
    "data-name": "Path 50504",
    d: "M12.262,207.984,10.007,206.4A3.929,3.929,0,0,0,8.5,204.47c-1.014-.586-1.837.036-1.837,1.389a4.4,4.4,0,0,0,1.837,3.51,1.155,1.155,0,0,0,1.246.069Zm8.543,4.993-2.255-1.586a3.928,3.928,0,0,0-1.51-1.927c-1.015-.586-1.837.036-1.837,1.389a4.4,4.4,0,0,0,1.837,3.51,1.155,1.155,0,0,0,1.246.069Zm0,0",
    transform: "translate(-6.376 -195.533)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50505",
    "data-name": "Path 50505",
    d: "M21.336,12.4l-.062.036a5.2,5.2,0,0,0-1.455-2.712L18.072,8l-.365-.679a10.393,10.393,0,0,0-3.972-4.091L8.122,0,.974,4.143.847,5.5A7.562,7.562,0,0,0,0,8.982v.247a2.469,2.469,0,0,0,1.233,2.138l11.708,6.773.03.019.054.03.06.035q.032.019.066.034l.017.007.058.022.008,0a2.5,2.5,0,0,0,2.238-.133l5.373-3.106A2.017,2.017,0,0,0,21.852,13.3V12.7A.344.344,0,0,0,21.336,12.4Zm0,0",
    transform: "translate(0)",
    fill: "#63dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50506",
    "data-name": "Path 50506",
    d: "M21.336,105.332l-6.312,3.649a1.8,1.8,0,0,1-.963.24,5.194,5.194,0,0,0-1.39-2.421l-1.747-1.72-.365-.679a10.393,10.393,0,0,0-3.972-4.091L.974,97.078.847,98.439A7.564,7.564,0,0,0,0,101.917v.247A2.469,2.469,0,0,0,1.233,104.3l11.708,6.773.03.019.054.03.06.035a.775.775,0,0,0,.148.066,2.5,2.5,0,0,0,2.238-.133l5.373-3.106a2.017,2.017,0,0,0,1.008-1.747v-.609A.344.344,0,0,0,21.336,105.332Zm0,0",
    transform: "translate(0 -92.935)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50507",
    "data-name": "Path 50507",
    d: "M210.5,324.984c0,1.353-.823,1.975-1.837,1.389a4.4,4.4,0,0,1-1.837-3.51c0-1.353.822-1.974,1.837-1.389A4.4,4.4,0,0,1,210.5,324.984Zm0,0",
    transform: "translate(-198.001 -307.543)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50508",
    "data-name": "Path 50508",
    d: "M230.513,354.885c0,.665-.4.971-.9.683a2.163,2.163,0,0,1-.9-1.726c0-.665.4-.971.9-.683A2.163,2.163,0,0,1,230.513,354.885Zm0,0",
    transform: "translate(-218.946 -337.983)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50509",
    "data-name": "Path 50509",
    d: "M239.375,368.121c0,.361-.219.527-.49.37a1.173,1.173,0,0,1-.49-.936c0-.361.219-.526.49-.37A1.173,1.173,0,0,1,239.375,368.121Zm0,0",
    transform: "translate(-228.22 -351.457)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50510",
    "data-name": "Path 50510",
    d: "M10.334,207.98c0,1.353-.823,1.975-1.837,1.389a4.4,4.4,0,0,1-1.837-3.51c0-1.353.823-1.974,1.837-1.389A4.4,4.4,0,0,1,10.334,207.98Zm0,0",
    transform: "translate(-6.376 -195.533)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50511",
    "data-name": "Path 50511",
    d: "M30.349,237.883c0,.665-.4.971-.9.683a2.163,2.163,0,0,1-.9-1.726c0-.665.4-.971.9-.683A2.163,2.163,0,0,1,30.349,237.883Zm0,0",
    transform: "translate(-27.325 -225.975)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50512",
    "data-name": "Path 50512",
    d: "M39.207,251.117c0,.361-.219.526-.49.37a1.173,1.173,0,0,1-.49-.936c0-.361.219-.527.49-.37A1.173,1.173,0,0,1,39.207,251.117Zm0,0",
    transform: "translate(-36.595 -239.447)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50513",
    "data-name": "Path 50513",
    d: "M234.647,135.387l6.424-3.723-1.437-2.141a1.256,1.256,0,0,0-1.677-.385l-3.994,2.333a1.335,1.335,0,0,0-.493,1.8Zm0,0",
    transform: "translate(-223.343 -123.462)",
    fill: "#304e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50514",
    "data-name": "Path 50514",
    d: "M461.95,267.938l-1.064.62a.5.5,0,0,0-.25.435v.879l1.614-.932A5.218,5.218,0,0,0,461.95,267.938Zm0,0",
    transform: "translate(-440.976 -256.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50515",
    "data-name": "Path 50515",
    d: "M484.416,269.12l.313-.181a5.191,5.191,0,0,0-.3-1l-.311.181A5.5,5.5,0,0,1,484.416,269.12Zm0,0",
    transform: "translate(-463.455 -256.502)",
    fill: "#ef9910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50516",
    "data-name": "Path 50516",
    d: "M301.613,346.982l1.179-.68v-.587a.341.341,0,0,0-.511-.3l-1.013.585a.669.669,0,0,1-.668,0l-.686-.4a1.433,1.433,0,0,0,.718,1.242l.23.132A.753.753,0,0,0,301.613,346.982Zm0,0",
    transform: "translate(-287.114 -330.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50517",
    "data-name": "Path 50517",
    d: "M300.885,351.362a.664.664,0,0,1-.285-.083l-.686-.4a1.433,1.433,0,0,0,.718,1.242l.23.132a.75.75,0,0,0,.35.1A5.19,5.19,0,0,0,300.885,351.362Zm0,0",
    transform: "translate(-287.114 -335.908)",
    fill: "#ef9910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50518",
    "data-name": "Path 50518",
    d: "M264.844,195.9l3.864,2.861,4.743-2.731-2.183-3.853Zm0,0",
    transform: "translate(-253.541 -183.978)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50519",
    "data-name": "Path 50519",
    d: "M132.133,182.734l4.69,2.648-1.358-1.931a4.837,4.837,0,0,0-1.538-1.406l-1.8-1.036Zm0,0",
    transform: "translate(-126.494 -173.283)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50520",
    "data-name": "Path 50520",
    d: "M325.95,131.592l-1.358-1.931a4.833,4.833,0,0,0-.57-.669,1.251,1.251,0,0,0-.651.17l-.848.5Zm0,0",
    transform: "translate(-308.758 -123.487)",
    fill: "#59718b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50521",
    "data-name": "Path 50521",
    d: "M36.12,143.52l-1.995-1.152a1.045,1.045,0,0,0-1.485.5l-.144.341,3.624,2.046Zm0,0",
    transform: "translate(-31.109 -136.158)",
    fill: "#243b58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchbakHighlighted);
export default __webpack_public_path__ + "static/media/hatchbakHighlighted.63813c834e26e7a5feace452a376026c.svg";
export { ForwardRef as ReactComponent };